import { createAnatomy } from "@ark-ui/react/anatomy";

export const imageAnatomy = createAnatomy("image", [
  "root",
  "image",
  "fallback",
  "loader",
]);
